<template>
  <div class="position-header">
    <navHeader :titleList="['买家展期约见', '买家展期约见详情']" />
    <div class="rhBrand-content common-padding" v-loading="loading">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="8">
            <el-form ref="form" class="add-form" :model="form" label-width="140px">
              <el-form-item label="预约买家姓名：">
                <el-input v-model="form.fromUserName" disabled></el-input>
              </el-form-item>
              <el-form-item label="预约买家手机号：">
                <el-input v-model="form.fromUserPhone" disabled></el-input>
              </el-form-item>
              <el-form-item label="预约买家公司名称：">
                <el-input v-model="form.fromCompanyName" disabled></el-input>
              </el-form-item>
              <el-form-item label="预约买家公司类型：">
                <el-input v-model="form.fromEnterpriseType" disabled></el-input>
              </el-form-item>
              <el-form-item label="预约时间：">
                <el-input v-model="form.meetDate" disabled></el-input>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button @click="back">返 回</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  data () {
    return {
      loading: false,
      form: {
        fromUserName: '',
        fromUserPhone: '',
        fromCompanyName: '',
        fromEnterpriseName: '',
        fromEnterpriseType: '',
        toUserName: '',
        toUserPhone: '',
        toCompanyName: '',
        otherEnterpriseName: '',
        startTime: '',
        endTime: '',
        meetDate: ''
      }
    }
  },
  components: {
    navHeader
  },
  created () {
    if (this.$route.query.id) {
      this.getData(this.$route.query.id)
    } else {
      this.loading = false
    }
  },
  methods: {
    async getData (id) {
      this.loading = true
      this.$http.post('/offlineMeet/getById', {id}).then(res => {
        if (res.data.code === '200') this.form = res.data.data
      }).finally(() => {
        this.loading = false
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/offlineReservation/detail.vue